"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _OrderDetail = _interopRequireDefault(require("@/components/OrderDetail"));
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _utils = require("@/utils");
var _permission = require("@/utils/permission");
var _OrderItemRefundStatus = _interopRequireDefault(require("@/components/OrderItemRefundStatus.vue"));
var _DivisionRecordPanel = _interopRequireDefault(require("@/components/OrderDetail/DivisionRecordPanel.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'orderlistDetails',
  components: {
    detailsFrom: _OrderDetail.default,
    merchantName: _merchantName.default,
    OrderItemRefundStatus: _OrderItemRefundStatus.default,
    DivisionRecordPanel: _DivisionRecordPanel.default
  },
  data: function data() {
    return {
      options: [{
        value: 0,
        label: '全部'
      }, {
        value: 2,
        label: '商城订单'
      }, {
        value: 1,
        label: '视频号订单'
      }],
      RefuseVisible: false,
      RefuseData: {},
      orderNo: '',
      parentHistoryVisible: false,
      parentHistoryInput: '',
      parentHistoryOrderNo: '',
      refundVisible: false,
      refundData: {},
      dialogVisibleJI: false,
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: 10,
        orderNo: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: {
        status: 'all',
        dateLimit: '',
        orderNo: '',
        page: 1,
        limit: 10,
        merId: null,
        type: '',
        searchType: 'all',
        content: ''
      },
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      fromType: [{
        value: '',
        text: '全部'
      }, {
        value: '0',
        text: '普通'
      }, {
        value: '1',
        text: '秒杀'
      }, {
        value: '2',
        text: '拼团'
      }],
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: (0, _utils.isWriteOff)(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['订单编号', '用户昵称', '订单类型', '收货人', '商户名称', '商品信息', '实际支付', '支付方式', '支付状态', '订单状态', '下单时间', '平台订单号', '商户内部订单号'],
      columnData: ['订单编号', '用户昵称', '订单类型', '收货人', '商户名称', '商品信息', '实际支付', '支付方式', '支付状态', '订单状态', '下单时间', '平台订单号', '商户内部订单号'],
      isIndeterminate: true
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:order:page:list'])) this.getList();
    if ((0, _permission.checkPermi)(['platform:order:status:num'])) this.getOrderStatusNum();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    checkAllPermi: _permission.checkAllPermi,
    queryParentHistory: function queryParentHistory() {
      if (!(0, _permission.checkAllPermi)(['platform:order:page:list', 'platform:order:info'])) return;
      var orderNo = this.parentHistoryInput.trim();
      if (!/^PT[0-9]{21}$/.test(orderNo)) {
        this.$message.warning('请填写完整的PT原支付单号');
        return;
      }
      if (orderNo === this.parentHistoryOrderNo && this.$refs.parentHistoryPanel) {
        if (!this.$refs.parentHistoryPanel.loading) this.$refs.parentHistoryPanel.loadData();
      } else {
        this.parentHistoryOrderNo = orderNo;
      }
    },
    closeParentHistory: function closeParentHistory() {
      this.parentHistoryVisible = false;
      this.parentHistoryInput = '';
      this.parentHistoryOrderNo = '';
    },
    getMerId: function getMerId(id) {
      this.tableFrom.merId = id;
      this.handleSearchList();
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    handleReset: function handleReset() {
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.tableFrom.status = 'all';
      this.tableFrom.dateLimit = '';
      this.tableFrom.orderNo = '';
      this.tableFrom.page = 1;
      this.tableFrom.merId = null;
      this.tableFrom.type = '';
      this.tableFrom.searchType = 'all';
      this.timeVal = [];
      this.handleSearchList();
    },
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 详情
    onOrderDetails: function onOrderDetails(id) {
      this.orderNo = id;
      this.$refs.orderDetail.getDetail(id);
      this.$refs.orderDetail.getOrderInvoiceList(id);
      this.$refs.orderDetail.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _order.orderListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total;
        _this.listLoading = false;
        _this.checkedCities = _this.$cache.local.has('order_stroge') ? _this.$cache.local.getJSON('order_stroge') : _this.checkedCities;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this2 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.status;
      return (0, _order.orderStatusNumApi)(data).then(function (res) {
        _this2.orderChartType = res;
      }).catch(function () {
        return undefined;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        status: this.tableFrom.status,
        type: this.tableFrom.type,
        merId: this.tableFrom.merId
      };
      (0, _order.orderExcelApi)(data).then(function (res) {
        window.open(res.fileName);
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.card_select_show = false;
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    }
  }
};